import React from "react";

const Footer = () => {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white px-6 py-3 dark:border-slate-800 dark:bg-slate-950">
      <div className="flex flex-col items-center justify-between gap-2 text-xs sm:flex-row">
        {/* Left Section */}
        <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400">
          <span className="font-extrabold tracking-wide text-slate-700 dark:text-slate-200">
            CLINIX
          </span>
          <span className="text-slate-500 dark:text-slate-800">|</span>
          <span>Hospital Management System</span>
        </div>

        {/* Right Section */}
        <div className="text-center text-slate-500 dark:text-slate-600 sm:text-right">
          © {new Date().getFullYear()}{" "}
          <span className="font-semibold text-slate-700 dark:text-slate-600">
            Sixfox Technology
          </span>
          <span className="mx-1.5">•</span>
          All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;